<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
<mat-toolbar class="toolbar" [style.backgroundColor]="'var(--mat-sys-primary)'"
  [style.color]="'var(--mat-sys-on-primary)'">
  <mat-toolbar-row>
    <span class="margin-auto">
      @if (sidenav && sidenav?.opened) {
      <button (click)="sidenavToggleFn()" mat-icon-button matTooltip="Close Sidebar">
        <mat-icon class="menu-trigger" fontIcon="mdi-chevron-left"></mat-icon>
      </button>
      }
      @if (sidenav && !sidenav?.opened) {
      <button (click)="sidenavToggleFn()" mat-icon-button matTooltip="Open Sidebar">
        <mat-icon class="menu-trigger" fontIcon="mdi-chevron-right"></mat-icon>
      </button>
      }
      <a mat-icon-button style="outline: none; background-color: var(--mat-sys-on-primary);" [routerLink]="['/']">
        <mat-icon svgIcon="crucible-icon-gallery"></mat-icon>
      </a>
    </span>
    <span class="view-text">{{ title.charAt(0).toUpperCase() + title.slice(1) }}</span>
    @if (teams && team && teams.length > 0) {
    <div class="team-text">Team:</div>
    <b class="team-text">{{ team.name }}</b>
    @if (teams.length > 1) {
    <div class="cssLayoutRowStartCenter">
      <button mat-button [matMenuTriggerFor]="teamMenu" style="outline: none;">
        <mat-icon class="menu-trigger" fontIcon="mdi-chevron-down"></mat-icon>
      </button>
      <mat-menu #teamMenu="matMenu" [overlapTrigger]="false">
        @for (val of teams; track val) {
        <button mat-menu-item (click)="setTeamFn(val.id)">
          {{ val.name }}
        </button>
        }
      </mat-menu>
    </div>
    }s
    }
    <span class="spacer"></span>
    @if (currentUser$ | async; as currentUser) {
    <div class="options-text">
      <button mat-button class="menu-trigger" [matMenuTriggerFor]="menu" style="outline: none;">
        <strong>{{ currentUser.name }}</strong>
        <mat-icon class="menu-trigger" fontIcon="mdi-chevron-down"></mat-icon>
      </button>
      <mat-menu #menu="matMenu" [overlapTrigger]="false">
        @if (topbarView === TopbarView.GALLERY_ADMIN) {
        <button [routerLink]="['/']" mat-menu-item>
          Exit Administration
        </button>
        }
        @if (topbarView !== TopbarView.GALLERY_ADMIN && canViewAdmin) {
        <button [routerLink]="['/admin']" mat-menu-item>
          Administration
        </button>
        }
        <button mat-menu-item (click)="logout()">Logout</button>
        <mat-slide-toggle class="mat-menu-item" color="primary"
          [checked]="(theme$ | async) === 'dark-theme' ? true : false" (click)="$event.stopPropagation()"
          (change)="themeFn($event)">
          Dark Theme
        </mat-slide-toggle>
      </mat-menu>
    </div>
    }
  </mat-toolbar-row>
</mat-toolbar>
